import { cva } from 'class-variance-authority';

const headerClass = cva('flex items-center justify-between p-4 cursor-pointer transition-colors', {
    variants: {
        open: {
            true: 'bg-transparent backdrop-blur-md',
            false: 'bg-transparent backdrop-blur-md',
        },
    },
});

export default function SimpleAccordion({ isOpen, onToggle, locked }) {
    return (
        <div className="box-wrapper mx-auto mt-6 rounded">
            <div className="box-inner overflow-hidden rounded">
                <div onClick={onToggle} className={`${headerClass({ open: isOpen })} ${locked ? 'pointer-events-none opacity-50' : ''}`}>
                    <span className="text-xl font-medium">
                        {locked ? 'Čas vypršel' : `Kliknutím na šipku se otevře příloha a spustí se odpočet času.`}
                    </span>
                    <div
                        className={`flex h-6 w-6 items-center justify-center rounded-full border bg-white transition-transform duration-300 ${
                            isOpen ? 'rotate-180' : ''
                        }`}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 text-gray-700"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>

                <div className={`overflow-hidden transition-[max-height] duration-500 ease-in-out ${isOpen ? 'max-h-500' : 'max-h-0'}`}>
                    {!locked && (
                        <div className="p-4 text-xl">
                            <p>
                                Média veřejné služby (např. v Česku Česká televize a Český rozhlas) jsou nezávislá média, která neslouží komerčním
                                zájmům ani politickým stranám, ale všem občanům. Nejde o státní média řízená vládou ani o&nbsp;soukromá média financovaná
                                reklamou. Jejich hlavním úkolem je informovat, vzdělávat a bavit – nestranně, vyváženě a ve veřejném zájmu. Jsou
                                pilířem demokracie. Média veřejné služby (např. Česká televize a Český rozhlas) jsou financována hlavně z tzv.
                                koncesionářských poplatků. To znamená, že každá domácnost nebo firma, která má televizi nebo rádio, platí měsíční
                                poplatek.
                            </p>
                            <p>
                                Média veřejné služby mají ze zákona povinnost sloužit celé společnosti, což znamená i respektovat a zohledňovat
                                potřeby různých skupin obyvatel – nejen většiny. Patří sem například: lidé se zdravotním znevýhodněním, děti a mládež,
                                národnostní a etnické menšiny, náboženské skupiny, senioři, venkovské regiony, sociálně znevýhodnění. Média veřejné
                                služby jsou pilířem demokracie, protože poskytují ověřené a úplné informace (nikoliv dezinformace), dávají prostor
                                různým názorům a posilují informovanou debatu ve společnosti. Demokracie stojí na vyváženém rozdělení zákonodárné,
                                výkonné a soudní moci, které se navzájem kontrolují a brání zneužití autority.
                            </p>
                            <p>
                                Na média veřejné služby dohlížejí nezávislé rady, které jsou zřízeny zákonem a mají za úkol zastupovat veřejnost při
                                kontrole činnosti těchto médií.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
